import { render, staticRenderFns } from "./ActivateExtensionPage.vue?vue&type=template&id=8e8bb3fa&scoped=true"
import script from "./ActivateExtensionPage.vue?vue&type=script&lang=js"
export * from "./ActivateExtensionPage.vue?vue&type=script&lang=js"
import style0 from "./ActivateExtensionPage.vue?vue&type=style&index=0&id=8e8bb3fa&prod&lang=css"
import style1 from "./ActivateExtensionPage.vue?vue&type=style&index=1&id=8e8bb3fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8bb3fa",
  null
  
)

export default component.exports